import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import { HeaderContent } from '../../../../components/HeaderContent';
import { Project } from '../../../../domain/project/Project';
import { StopFields } from './StopFields';
import { TaskFields } from './tasks';

interface DriversPODCompletedProps {
  project: Project;
}

export const DriversPODCompleted = ({ project }: DriversPODCompletedProps) => {
  // const { data: user } = useRetrieveUser();
  // const { retrieveDoc } = useRetrieveSupportDocs();

  return (
    <Grid container direction="column" wrap="nowrap" style={{ height: `100%` }}>
      <HeaderContent
        titleIntlId="drivers.pod.stop_completed_fields.title"
        styles={{
          container: {
            padding: `11px 20px`,
            backgroundColor: RoutalPalette.neutral02n,
            borderBottom: `1px solid ${RoutalPalette.neutral10}`,
            maxHeight: `120px`,
          },
        }}
      />

      <Grid
        container
        direction="column"
        wrap="nowrap"
        style={{
          padding: `20px 20px 0px 20px`,
          height: `calc(100% - 92px)`,
          backgroundColor: RoutalPalette.neutral00,
          overflowY: `auto`,
        }}
      >
        <Grid item>
          <StopFields project={project} />
        </Grid>

        <Grid item>
          <VSpacer medium />
          <TaskFields project={project} />
        </Grid>
      </Grid>
    </Grid>
  );
};
